<template>
  <BaseDialogForm :is-edit="true">
    <template v-slot:toggle="{ on }">
      <v-btn icon color="primary" v-on="on">
        <v-icon>
          edit
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      <h2>Edit {{ instance.name }}</h2>
    </template>
    <template v-slot:content>
      <v-form v-model="$v.valid" @submit.prevent="submit">
        <v-text-field
          v-model.trim="$v.formdata.name.$model"
          :error-messages="nameErrors"
          :label="formdata.label"
          :counter="formdata.counter"
          :prepend-icon="formdata.icon"
          :hint="formdata.hint"
          @input="$v.formdata.name.$touch()"
          @blur="$v.formdata.name.$touch()"
        />
      </v-form>
    </template>
    <template v-slot:actions="{ close }">
      <v-btn color="warning" dark @click="clear">
        <v-icon left>fas fa-redo</v-icon>
        Clear
      </v-btn>
      <v-btn
        :disabled="$v.$invalid"
        color="primary"
        @click="
          submit();
          close();
        "
      >
        <v-icon dark left>
          fas fa-save
        </v-icon>
        Save
      </v-btn>
    </template>
  </BaseDialogForm>
</template>

<script>
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import BaseDialogForm from "../Base/BaseDialogForm";
import Supplier from "../../models/Supplier";
export default {
  name: "SupplierFormEdit",
  mixins: [validationMixin],
  validations: Supplier.validations,
  components: { BaseDialogForm },
  props: {
    instance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      formdata: new Supplier(this.instance)
    };
  },
  computed: {
    nameErrors() {
      return handleErrors("formdata", "name", this);
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      Supplier.$put(this.instance.id, this.formdata.toUpdatePayload());
    },
    clear() {
      this.$v.$reset();
    }
  }
};
</script>
